import { render, staticRenderFns } from "./CNAE.vue?vue&type=template&id=764fb7c2&"
import script from "./CNAE.vue?vue&type=script&lang=js&"
export * from "./CNAE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports